import {type ThemeColorPath} from 'platform/foundation';

/** Series colours of the ABC/XYZ detail charts, addressed by role. */
export const ABC_XYZ_CHART_COLORS = {
  primary: 'palettes.blue.60.100',
  accent: 'palettes.purple.60.100',
  highlight: 'palettes.orange.60.100',
} as const satisfies Record<string, ThemeColorPath>;
